import { render, staticRenderFns } from "./SavedResearchList.vue?vue&type=template&id=08005650&"
import script from "./SavedResearchList.vue?vue&type=script&lang=js&"
export * from "./SavedResearchList.vue?vue&type=script&lang=js&"
import style0 from "./SavedResearchList.vue?vue&type=style&index=0&id=08005650&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports